var t = /* @__PURE__ */ ((r) => (r.INFO = "info", r.ERROR = "error", r.ATTENTION = "attention", r.NOTICE = "notice", r.SUCCESS = "success", r))(t || {}), I = /* @__PURE__ */ ((r) => (r.MEDIUM = "m", r.SMALL = "s", r.XSMALL = "xs", r))(I || {});
export {
  I as ECommonMessageSize,
  t as ECommonMessageType
};
//# sourceMappingURL=CommonMessage.types.mjs.map
